<template>
  <div>
    <div class="setting-item clearFloat">
      <div class="content">
        <div class="content-item floatLeft">
          <div class="font-arrangement-btn">
            <span class="btn-active" :style="getTranslate"></span>
            <el-tooltip
              v-for="(val, index) in arrangementList"
              :key="index"
              class="item"
              effect="dark"
              :content="val.label"
              placement="top-end"
              :open-delay="1000"
            >
              <span
                :key="index"
                :class="overFlowStyle == val.value ? 'select pd2' : 'pd2'"
                @click="changeArrangement(val, '')"
              ><i :class="val.className"></i></span>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="当内容超出时，自动显示滚动条"
              placement="top-end"
              :open-delay="1000"
            >
              <span :class="overFlowStyle == 'auto' ? ' select pd2' : ' pd2'" @click="changeArrangementAuto('auto')"
                >自动</span
              >
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../common.css"
import publicData from "../mixins/publicData.js"

export default {
  mixins: [ publicData],
  name: "textSettingOverflow",
  props: {
    overFlowType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      arrangementList: [
        {
          label: "显示超出的内容",
          className: "icon-portal-preview-open1",
          value: "visible"
        },
        {
          label: "隐藏超出的内容",
          className: "icon-portal-preview-close-one1",
          value: "hidden"
        },
        {
          label: "始终显示滚动条",
          className: "icon-portal-scroll",
          value: "scroll"
        }
      ],
      translate: 0,
    }
  },
  mounted() {},
  watch: {},
  computed: {
    overFlowStyle: {
      get() {
        let type = this.overFlowType
        let index = this.arrangementList.findIndex(item => item.value === type)
        if(this.overFlowType == 'auto') index = 3
        // 44.5 一个滑块的宽度
        this.translate = 44.5*index
        return this.overFlowType
      },
      set(val) {
        this.$emit("update:overFlowType", val)
      }
    },
    getTranslate() {
      return {
        "transform": `translateX(${this.translate}px)`
      }
    },
  },
  methods: {
    changeArrangement(val, hoverFlag) {
      this.overFlowStyle = val.value
    },
    changeArrangementAuto(val) {
      this.overFlowStyle = val
    }
  }
}
</script>

<style scoped>
.font-arrangement-btn span:last-child {
  top: -1px;
}
.content,
.content-item {
  width: 100%;
}
.font-arrangement-btn span {
  width: calc((100% / 4));
}
.font-arrangement-btn span.btn-active {
  width: calc((100% - 6px) / 4);
}
.font-arrangement-btn span:last-child {
  font-size: 13px;
}
</style>
